import { Coverage } from "@medplum/fhirtypes";

import { Extensions } from "@/fhir/enums/extensions";
import { removeExtensions } from "@/utils/medplum";

/**
 * Coverage fields that insurance verification owns. Intake owns the payor and identity fields and
 * keeps these across its saves while the payor stays the same Organization.
 */
export const VERIFICATION_COVERAGE_FIELDS = [
  "period",
  "costToBeneficiary",
  "network",
] as const satisfies readonly (keyof Coverage)[];

/** Coverage extension URLs that insurance verification owns. */
export const VERIFICATION_COVERAGE_EXTENSIONS: string[] = [Extensions.CoverageVerificationDetails];

/**
 * Removes the verification-owned fields and extensions from a Coverage.
 * @param coverage The Coverage to strip.
 * @returns A copy of the Coverage without verification data; other extensions are kept.
 */
export function removeVerificationCoverageFields(coverage: Coverage): Coverage {
  const unverifiedCoverage: Coverage = { ...coverage };
  for (const field of VERIFICATION_COVERAGE_FIELDS) delete unverifiedCoverage[field];

  const keptExtensions = removeExtensions(coverage.extension, VERIFICATION_COVERAGE_EXTENSIONS);
  if (keptExtensions.length > 0) unverifiedCoverage.extension = keptExtensions;
  else delete unverifiedCoverage.extension;

  return unverifiedCoverage;
}
